<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    width="460px"
    @close="handleClose"
  >
    <div v-if="!uploadSuccess">
      <p>请先<a
        style="color:blue"
        @click="handleExport"
      >下载模板</a></p>
      <el-row>
        <el-col :span="6">选择导入文件</el-col>
        <el-col :span="18">
          <el-form>
            <el-upload
              ref="upload"
              :action="action"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-change="handleChange"
              :before-upload="handleBeforeUpload"
              :file-list="fileList"
              :auto-upload="false"
              :multiple="false"
              :headers="headers"
              :data="data"
              accept=".xls,.xlsx"
              name="file"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
              >选取文件</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >文件大小不可超过20M，支持.xls和.xlsx格式</div>
            </el-upload>
          </el-form>
        </el-col>
        <el-col style="color:red">注意：如重新上传，则已上传的数据将会被全部清除，请谨慎操作！</el-col>
      </el-row>
      <el-row
        slot="footer"
        style="margin-top:15px;"
      >
        <el-col
          :span="18"
          :offset="6"
        >
          <el-form>
            <span>
              <el-button
                type="primary"
                @click="submitUpload"
              >开始导入</el-button>
              <el-button @click="handleClose">取 消</el-button>
            </span>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <p>{{ $t('Warehouse.ImportingData') }}...</p>
      <p style="color:red">{{ $t('Warehouse.ThisOperationIsAnAsynchronousImport') }}</p>
      <div
        slot="footer"
        style="text-align:center"
      >
        <span>
          <el-button
            type="primary"
            @click="handleClose"
          >{{ $t('Message.GotIt') }}</el-button>
          <el-button @click="searchResult">{{ $t('Warehouse.ViewResults') }}</el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils/auth'
export default {
  name: 'ImportDialog',
  props: {
    title: { type: String, default: () => '' },
    visible: { type: Boolean, default: () => false },
    isAsync: { type: Boolean, default: () => false },
    action: { type: String, default: () => '' },
    data: { type: Object, default: () => null },
    templateParams: { type: Object, default: () => {} }
  },
  data() {
    return {
      fileList: [],
      uploadSuccess: false,
      headers: {
        sessionId: getToken(),
        ContentType: 'multipart/form-data'
      }
    }
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        this.fileLsit = fileList.shift()
      }
    },
    handleBeforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('文件大小不能超过20MB!')
      }
      return isLt20M
    },
    handleSuccess() {
      this.uploadSuccess = true
      if (!this.isAsync) {
        this.$message.success(this.$t('SeaExport.UploadSuccess'))
        this.$emit('onClose')
      }
    },
    handleError(err) {
      console.log(err)
      this.$message.error('上传失败')
    },
    handleClose() {
      this.fileList = []
      this.$emit('onClose')
    },
    handleExport() {
      this.$emit('handleExport')
    },
    searchResult() {
      this.$router.push({
        name: 'PriceFileManager'
      })
      this.$emit('onClose')
    }
  }
}
</script>
